import { EXTERNAL_FONT, INTERNAL_FONT } from '../../config/deploymentProfile';

export const themes = {
  'academic': {
    id: 'academic',
    name: 'Academic',
    background: '#FFFFFF',
    plotBackground: '#FFFFFF',
    foreground: '#000000',
    axisColor: '#000000',
    gridColor: '#000000',
    gridAlpha: 0.1,
    tickColor: '#000000',
    labelColor: '#000000',
    titleColor: '#000000',
    legendTextColor: '#000000',
    referenceLineColor: '#C44B3D',
    fontHeading: INTERNAL_FONT.labelFamily,
    fontBody: INTERNAL_FONT.labelFamily,
    fontLabel: INTERNAL_FONT.labelFamily,
    fontNumber: INTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#4C6EE6', '#C44B3D', '#9E4FA5', '#3B5F5C'],
    paletteSequential: ['#DBE0F2', '#8FA6F9', '#4C6EE6', '#2D4DB9', '#1E265C'],
    ui: {
      bg: '#FFFFFF',
      bgSecondary: '#F9FAFB',
      text: '#000000',
      textSecondary: '#374151',
      border: '#000000',
      borderSecondary: '#9CA3AF',
      hover: '#E5E7EB',
      accent: '#000000',
      accentFg: '#FFFFFF',
      scrollTrack: '#F0F0F0',
      scrollThumb: '#000000',
      overlayBackdrop: 'rgba(17, 24, 39, 0.35)',
      emptyStateText: '#6B7280',
      codeKeyword: '#000000',
      codeString: '#4B5563',
      codeComment: '#9CA3AF',
      codeNumber: '#374151',
    },
  },
  'tiny-aya-dark': {
    id: 'tiny-aya-dark',
    name: 'Tiny Aya Dark',
    locked: true,
    background: '#16270D',
    plotBackground: '#1E3314',
    foreground: '#FFFFFF',
    axisColor: 'rgba(255,255,255,0.30)',
    gridColor: 'rgba(207,233,180,0.08)',
    gridAlpha: 1,
    tickColor: '#FFFFFF',
    labelColor: '#FFFFFF',
    titleColor: '#FFFFFF',
    legendTextColor: '#FFFFFF',
    referenceLineColor: '#8FA6F9',
    fontHeading: INTERNAL_FONT.labelFamily,
    fontBody: INTERNAL_FONT.labelFamily,
    fontLabel: INTERNAL_FONT.labelFamily,
    fontNumber: INTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#5DBF8A', '#4C6EE6', '#8FA6F9', '#CBEFFF'],
    paletteSequential: ['#16270D', '#274D2C', '#39734B', '#4A996A', '#5DBF8A'],
    ui: {
      bg: '#16270D',
      bgSecondary: '#1E3314',
      text: '#FFFFFF',
      textSecondary: 'rgba(255,255,255,0.5)',
      border: 'rgba(207,233,180,0.25)',
      borderSecondary: 'rgba(207,233,180,0.12)',
      hover: 'rgba(255,255,255,0.08)',
      accent: '#5DBF8A',
      accentFg: '#16270D',
      scrollTrack: '#0F1A07',
      scrollThumb: '#5DBF8A',
      overlayBackdrop: 'rgba(7, 10, 5, 0.72)',
      emptyStateText: 'rgba(255,255,255,0.64)',
      codeKeyword: '#CFE9B4',
      codeString: '#8FA6F9',
      codeComment: 'rgba(255,255,255,0.45)',
      codeNumber: '#5DBF8A',
    },
  },
  'north-dark': {
    id: 'north-dark',
    name: 'North Dark',
    locked: true,
    background: '#062C22',
    plotBackground: '#062C22',
    foreground: '#F5F5F5',
    axisColor: 'rgba(205,249,185,0.32)',
    gridColor: 'rgba(205,249,185,0.14)',
    gridAlpha: 1,
    tickColor: '#F5F5F5',
    labelColor: '#F5F5F5',
    titleColor: '#F5F5F5',
    legendTextColor: '#F5F5F5',
    referenceLineColor: '#CDF9B9',
    fontHeading: INTERNAL_FONT.labelFamily,
    fontBody: INTERNAL_FONT.labelFamily,
    fontLabel: INTERNAL_FONT.labelFamily,
    fontNumber: INTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#CDF9B9', '#A4E595', '#5FA87A', '#014431'],
    paletteSequential: ['#062C22', '#014431', '#2F6B4F', '#A4E595', '#CDF9B9'],
    ui: {
      bg: '#062C22',
      bgSecondary: '#014431',
      text: '#F5F5F5',
      textSecondary: 'rgba(245,245,245,0.68)',
      border: 'rgba(205,249,185,0.28)',
      borderSecondary: 'rgba(205,249,185,0.14)',
      hover: 'rgba(205,249,185,0.10)',
      accent: '#CDF9B9',
      accentFg: '#062C22',
      scrollTrack: '#041A15',
      scrollThumb: '#CDF9B9',
      overlayBackdrop: 'rgba(1, 12, 9, 0.74)',
      emptyStateText: 'rgba(245,245,245,0.72)',
      codeKeyword: '#CDF9B9',
      codeString: '#A4E595',
      codeComment: 'rgba(245,245,245,0.45)',
      codeNumber: '#CDF9B9',
    },
  },
  'north-light': {
    id: 'north-light',
    name: 'North Light',
    locked: true,
    background: '#F6FCF4',
    plotBackground: '#F6FCF4',
    foreground: '#014431',
    axisColor: 'rgba(1,68,49,0.40)',
    gridColor: 'rgba(1,68,49,0.12)',
    gridAlpha: 1,
    tickColor: '#014431',
    labelColor: '#014431',
    titleColor: '#014431',
    legendTextColor: '#014431',
    referenceLineColor: '#014431',
    fontHeading: INTERNAL_FONT.labelFamily,
    fontBody: INTERNAL_FONT.labelFamily,
    fontLabel: INTERNAL_FONT.labelFamily,
    fontNumber: INTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#014431', '#5FA87A', '#A4E595', '#CDF9B9'],
    paletteSequential: ['#F6FCF4', '#CDF9B9', '#A4E595', '#5FA87A', '#014431'],
    ui: {
      bg: '#F6FCF4',
      bgSecondary: '#ECF7E8',
      text: '#014431',
      textSecondary: 'rgba(1,68,49,0.84)',
      border: 'rgba(1,68,49,0.34)',
      borderSecondary: 'rgba(1,68,49,0.22)',
      hover: 'rgba(1,68,49,0.10)',
      accent: '#014431',
      accentFg: '#F5F5F5',
      scrollTrack: '#E4F1DE',
      scrollThumb: '#014431',
      overlayBackdrop: 'rgba(1, 12, 9, 0.42)',
      emptyStateText: 'rgba(1,68,49,0.82)',
      codeKeyword: '#014431',
      codeString: '#5FA87A',
      codeComment: 'rgba(1,68,49,0.46)',
      codeNumber: '#2F6B4F',
    },
  },
  'embed-dark': {
    id: 'embed-dark',
    name: 'Embed Dark',
    locked: true,
    background: '#131037',
    plotBackground: '#131037',
    foreground: '#F5F5F5',
    axisColor: 'rgba(131,228,252,0.34)',
    gridColor: 'rgba(131,228,252,0.12)',
    gridAlpha: 1,
    tickColor: '#F5F5F5',
    labelColor: '#F5F5F5',
    titleColor: '#F5F5F5',
    legendTextColor: '#F5F5F5',
    referenceLineColor: '#83E4FC',
    fontHeading: INTERNAL_FONT.labelFamily,
    fontBody: INTERNAL_FONT.labelFamily,
    fontLabel: INTERNAL_FONT.labelFamily,
    fontNumber: INTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#83E4FC', '#738EFC', '#4B6EFB', '#C3CCFF'],
    paletteSequential: ['#131037', '#28306B', '#4B6EFB', '#738EFC', '#83E4FC'],
    ui: {
      bg: '#131037',
      bgSecondary: '#1C1748',
      text: '#F5F5F5',
      textSecondary: 'rgba(245,245,245,0.68)',
      border: 'rgba(131,228,252,0.28)',
      borderSecondary: 'rgba(131,228,252,0.14)',
      hover: 'rgba(131,228,252,0.10)',
      accent: '#83E4FC',
      accentFg: '#131037',
      scrollTrack: '#0D0A24',
      scrollThumb: '#83E4FC',
      overlayBackdrop: 'rgba(8, 8, 25, 0.78)',
      emptyStateText: 'rgba(245,245,245,0.72)',
      codeKeyword: '#83E4FC',
      codeString: '#C3CCFF',
      codeComment: 'rgba(245,245,245,0.45)',
      codeNumber: '#738EFC',
    },
  },
  'embed-light': {
    id: 'embed-light',
    name: 'Embed Light',
    locked: true,
    background: '#F7F8FF',
    plotBackground: '#F7F8FF',
    foreground: '#131037',
    axisColor: 'rgba(19,16,55,0.36)',
    gridColor: 'rgba(75,110,251,0.12)',
    gridAlpha: 1,
    tickColor: '#131037',
    labelColor: '#131037',
    titleColor: '#131037',
    legendTextColor: '#131037',
    referenceLineColor: '#4B6EFB',
    fontHeading: INTERNAL_FONT.labelFamily,
    fontBody: INTERNAL_FONT.labelFamily,
    fontLabel: INTERNAL_FONT.labelFamily,
    fontNumber: INTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#4B6EFB', '#83E4FC', '#738EFC', '#131037'],
    paletteSequential: ['#F7F8FF', '#C3CCFF', '#83E4FC', '#738EFC', '#131037'],
    ui: {
      bg: '#F7F8FF',
      bgSecondary: '#EEF1FF',
      text: '#131037',
      textSecondary: 'rgba(19,16,55,0.84)',
      border: 'rgba(19,16,55,0.28)',
      borderSecondary: 'rgba(19,16,55,0.18)',
      hover: 'rgba(75,110,251,0.10)',
      accent: '#4B6EFB',
      accentFg: '#F5F5F5',
      scrollTrack: '#E5E9FF',
      scrollThumb: '#4B6EFB',
      overlayBackdrop: 'rgba(8, 8, 25, 0.42)',
      emptyStateText: 'rgba(19,16,55,0.82)',
      codeKeyword: '#131037',
      codeString: '#4B6EFB',
      codeComment: 'rgba(19,16,55,0.46)',
      codeNumber: '#738EFC',
    },
  },
  'command-dark': {
    id: 'command-dark',
    name: 'Command Dark',
    locked: true,
    background: '#00211E',
    plotBackground: '#00211E',
    foreground: '#F5F5F5',
    axisColor: 'rgba(199,252,254,0.34)',
    gridColor: 'rgba(3,197,177,0.16)',
    gridAlpha: 1,
    tickColor: '#F5F5F5',
    labelColor: '#F5F5F5',
    titleColor: '#F5F5F5',
    legendTextColor: '#F5F5F5',
    referenceLineColor: '#FC3F21',
    fontHeading: INTERNAL_FONT.labelFamily,
    fontBody: INTERNAL_FONT.labelFamily,
    fontLabel: INTERNAL_FONT.labelFamily,
    fontNumber: INTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#FC3F21', '#03C5B1', '#6BE7E3', '#C7FCFE'],
    paletteSequential: ['#00211E', '#015D56', '#03C5B1', '#77E8E6', '#C7FCFE'],
    ui: {
      bg: '#00211E',
      bgSecondary: '#01302C',
      text: '#F5F5F5',
      textSecondary: 'rgba(245,245,245,0.68)',
      border: 'rgba(199,252,254,0.30)',
      borderSecondary: 'rgba(199,252,254,0.14)',
      hover: 'rgba(3,197,177,0.10)',
      accent: '#FC3F21',
      accentFg: '#F5F5F5',
      scrollTrack: '#001512',
      scrollThumb: '#03C5B1',
      overlayBackdrop: 'rgba(0, 11, 10, 0.78)',
      emptyStateText: 'rgba(245,245,245,0.72)',
      codeKeyword: '#FC3F21',
      codeString: '#C7FCFE',
      codeComment: 'rgba(245,245,245,0.45)',
      codeNumber: '#03C5B1',
    },
  },
  'command-light': {
    id: 'command-light',
    name: 'Command Light',
    locked: true,
    background: '#F5FBFB',
    plotBackground: '#F5FBFB',
    foreground: '#00211E',
    axisColor: 'rgba(0,33,30,0.34)',
    gridColor: 'rgba(3,197,177,0.14)',
    gridAlpha: 1,
    tickColor: '#00211E',
    labelColor: '#00211E',
    titleColor: '#00211E',
    legendTextColor: '#00211E',
    referenceLineColor: '#FC3F21',
    fontHeading: INTERNAL_FONT.labelFamily,
    fontBody: INTERNAL_FONT.labelFamily,
    fontLabel: INTERNAL_FONT.labelFamily,
    fontNumber: INTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#FC3F21', '#03C5B1', '#6BE7E3', '#00211E'],
    paletteSequential: ['#F5FBFB', '#C7FCFE', '#6BE7E3', '#03C5B1', '#00211E'],
    ui: {
      bg: '#F5FBFB',
      bgSecondary: '#ECF7F6',
      text: '#00211E',
      textSecondary: 'rgba(0,33,30,0.84)',
      border: 'rgba(0,33,30,0.28)',
      borderSecondary: 'rgba(0,33,30,0.18)',
      hover: 'rgba(3,197,177,0.10)',
      accent: '#FC3F21',
      accentFg: '#F5F5F5',
      scrollTrack: '#DFF4F2',
      scrollThumb: '#03C5B1',
      overlayBackdrop: 'rgba(0, 11, 10, 0.42)',
      emptyStateText: 'rgba(0,33,30,0.84)',
      codeKeyword: '#00211E',
      codeString: '#03C5B1',
      codeComment: 'rgba(0,33,30,0.46)',
      codeNumber: '#FC3F21',
    },
  },
  'rerank-dark': {
    id: 'rerank-dark',
    name: 'Rerank Dark',
    locked: true,
    background: '#240437',
    plotBackground: '#240437',
    foreground: '#F5F5F5',
    axisColor: 'rgba(230,189,239,0.30)',
    gridColor: 'rgba(199,106,220,0.16)',
    gridAlpha: 1,
    tickColor: '#F5F5F5',
    labelColor: '#F5F5F5',
    titleColor: '#F5F5F5',
    legendTextColor: '#F5F5F5',
    referenceLineColor: '#E6BDEF',
    fontHeading: INTERNAL_FONT.labelFamily,
    fontBody: INTERNAL_FONT.labelFamily,
    fontLabel: INTERNAL_FONT.labelFamily,
    fontNumber: INTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#9A6FFF', '#C76ADC', '#E6BDEF', '#B98CFF'],
    paletteSequential: ['#240437', '#5D1E79', '#9A6FFF', '#C76ADC', '#E6BDEF'],
    ui: {
      bg: '#240437',
      bgSecondary: '#34094E',
      text: '#F5F5F5',
      textSecondary: 'rgba(245,245,245,0.68)',
      border: 'rgba(230,189,239,0.26)',
      borderSecondary: 'rgba(230,189,239,0.12)',
      hover: 'rgba(154,111,255,0.12)',
      accent: '#9A6FFF',
      accentFg: '#240437',
      scrollTrack: '#190326',
      scrollThumb: '#C76ADC',
      overlayBackdrop: 'rgba(16, 2, 25, 0.80)',
      emptyStateText: 'rgba(245,245,245,0.72)',
      codeKeyword: '#9A6FFF',
      codeString: '#E6BDEF',
      codeComment: 'rgba(245,245,245,0.45)',
      codeNumber: '#C76ADC',
    },
  },
  'rerank-light': {
    id: 'rerank-light',
    name: 'Rerank Light',
    locked: true,
    background: '#FCF7FD',
    plotBackground: '#FCF7FD',
    foreground: '#240437',
    axisColor: 'rgba(36,4,55,0.34)',
    gridColor: 'rgba(199,106,220,0.14)',
    gridAlpha: 1,
    tickColor: '#240437',
    labelColor: '#240437',
    titleColor: '#240437',
    legendTextColor: '#240437',
    referenceLineColor: '#9A6FFF',
    fontHeading: INTERNAL_FONT.labelFamily,
    fontBody: INTERNAL_FONT.labelFamily,
    fontLabel: INTERNAL_FONT.labelFamily,
    fontNumber: INTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#9A6FFF', '#C76ADC', '#E6BDEF', '#240437'],
    paletteSequential: ['#FCF7FD', '#E6BDEF', '#C76ADC', '#9A6FFF', '#240437'],
    ui: {
      bg: '#FCF7FD',
      bgSecondary: '#F6EEFA',
      text: '#240437',
      textSecondary: 'rgba(36,4,55,0.84)',
      border: 'rgba(36,4,55,0.28)',
      borderSecondary: 'rgba(36,4,55,0.18)',
      hover: 'rgba(154,111,255,0.10)',
      accent: '#9A6FFF',
      accentFg: '#F5F5F5',
      scrollTrack: '#EFE0F4',
      scrollThumb: '#C76ADC',
      overlayBackdrop: 'rgba(16, 2, 25, 0.44)',
      emptyStateText: 'rgba(36,4,55,0.84)',
      codeKeyword: '#240437',
      codeString: '#9A6FFF',
      codeComment: 'rgba(36,4,55,0.46)',
      codeNumber: '#C76ADC',
    },
  },
  'external-default': {
    id: 'external-default',
    name: 'External Default',
    locked: true,
    background: '#FFFFFF',
    plotBackground: '#FFFFFF',
    foreground: '#111827',
    axisColor: '#111827',
    gridColor: '#CBD5E1',
    gridAlpha: 0.6,
    tickColor: '#111827',
    labelColor: '#111827',
    titleColor: '#111827',
    legendTextColor: '#111827',
    referenceLineColor: '#BF0040',
    fontHeading: EXTERNAL_FONT.labelFamily,
    fontBody: EXTERNAL_FONT.labelFamily,
    fontLabel: EXTERNAL_FONT.labelFamily,
    fontNumber: EXTERNAL_FONT.numberFamily,
    tickSize: 13,
    labelSize: 15,
    legendSize: 12,
    legendMarkerSize: 14,
    valueLabelSize: 12,
    axisSpacingPreset: 'comfortable',
    axisTickGapX: 8,
    axisTickGapY: 7,
    axisTickBaselineNudgeX: 2,
    axisTickBaselineNudgeXNumeric: 1,
    axisTickBaselineNudgeXCategorical: 2,
    axisTickLengthX: 4,
    axisTickLengthY: 4,
    axisTitleMinOffset: 16,
    axisTitleMinInset: 10,
    axisTitleGapScale: 1.35,
    axisTickLabelLanePadX: 2,
    axisTickLabelLanePadY: 2,
    spineWidth: 1,
    barRadius: 4,
    palette: ['#2000DF', '#007840', '#BF0040', '#6366F1'],
    paletteSequential: ['#DBE0F2', '#8FA6F9', '#4C6EE6', '#2D4DB9', '#1E265C'],
    ui: {
      bg: '#FFFFFF',
      bgSecondary: '#F9FAFB',
      text: '#000000',
      textSecondary: '#374151',
      border: '#000000',
      borderSecondary: '#9CA3AF',
      hover: '#E5E7EB',
      accent: '#000000',
      accentFg: '#FFFFFF',
      scrollTrack: '#F0F0F0',
      scrollThumb: '#000000',
      overlayBackdrop: 'rgba(17, 24, 39, 0.35)',
      emptyStateText: '#6B7280',
      codeKeyword: '#111827',
      codeString: '#4B5563',
      codeComment: '#9CA3AF',
      codeNumber: '#374151',
    },
  },
};

export const DEFAULT_THEME = 'academic';

export function getTheme(themeId) {
  return themes[themeId] || themes[DEFAULT_THEME];
}

/**
 * Resolve style tokens for both preview rendering and code generation.
 * Single source of truth so preview ↔ matplotlib output stay in sync.
 *
 * @param {object} theme   – resolved theme object (from ThemeContext or getTheme)
 * @returns {object} flat style tokens consumed by previews + code gen helpers
 */
export function resolveStyle(theme) {
  const t = theme || themes[DEFAULT_THEME];
  const defaultFont = t.fontBody || 'Cohere Text';
  const labelFont = t.fontLabel || t.fontHeading || defaultFont;
  const numberFont = t.fontNumber || defaultFont;

  return {
    // Canvas
    figBackground: t.background,
    plotBackground: t.plotBackground,

    // Text
    titleColor: t.titleColor,
    titleSize: 14,
    labelColor: t.labelColor,
    labelSize: t.labelSize ?? 15,
    tickColor: t.tickColor,
    tickSize: t.tickSize ?? 13,
    foreground: t.foreground,
    legendTextColor: t.legendTextColor,
    legendSize: t.legendSize ?? 12,
    legendMarkerSize: t.legendMarkerSize ?? 14,
    valueLabelSize: t.valueLabelSize ?? 12,

    // Axes & spines
    axisColor: t.axisColor,
    spineWidth: t.spineWidth,

    // Grid
    gridColor: t.gridColor,
    gridAlpha: t.gridAlpha,

    // Typography
    fontFamily: defaultFont,
    fontHeading: t.fontHeading || labelFont,
    fontLabel: labelFont,
    fontNumber: numberFont,
    fontLabelFile: t.fontLabelFile,
    fontNumberFile: t.fontNumberFile,

    // Shapes
    barRadius: t.barRadius ?? 4,

    // Shared theme colors for previews + exported code
    palette: t.palette,
    paletteSequential: t.paletteSequential,
    referenceLineColor: t.referenceLineColor || '#C44B3D',
  };
}
